import { Component } from "preact";

import { submitTicket } from "./../../../api";
import { getFormErrorData, Button } from "./../../Helpers";
import {
  InputText,
  InputFile,
  InputRadioButton,
  InputTextArea,
} from "./../../FormFields";
import Loader from "../../../utils/Loader";
import Alert from "../../../utils/Alert";

import layoutStyle from "./../../App/layout.scss";
import style from "./index.scss";
import PGBackIcon from "../../../assets/icons/PGBackIcon";

export default class ReportIssueV2 extends Component {
  constructor(props) {
    super(props);

    this.zendeskFormChange = this.zendeskFormChange.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      title: this.props.type === "featureRequest" ? "New Feature Idea Submitted" : "",
      description: "",
      userEmails: "",
      files: null,
      type: this.props.type === "featureRequest" ? "Feature Idea / Enhancement" : "Bug / Technical Issue",
      userEmailRadio: "",
      issuePage: "",
      issueType: "bug",
      problemNature: "",
      formError: {
        title: {
          isError: false,
          type: "text",
        },
        description: {
          isError: false,
          type: "text",
        },
      },
    };
  }

  componentDidMount() {
    this.setState({
      issueType: this.props.type || "bug",
    });
    this.updateOptionalChecks();
    setTimeout(() => {
      const elem = document.getElementById("title");
      elem && elem.focus();
    }, 0);
  }

  validateData() {
    if (this.state.formError && typeof this.state.formError === "object") {
      const { formError, isValid } = getFormErrorData(this.state);

      if (!isValid) {
        const [firstNameWithError] = Object.keys(formError).filter(
          (name) => formError[name].isError
        );
        const list = document.getElementsByName(firstNameWithError);
        list.forEach((formElement, index) => {
          if (index === 0) {
            formElement.focus();
          }
        });
      }

      this.setState({ formError });
      return isValid;
    }
    return true;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (!this.validateData()) {
      return;
    }
    const {
      description,
      issuePage,
      problemNature,
      files,
      title,
      type,
      issueType,
    } = this.state;
    // Send empty issueType if bug else issueType
    const issueTypeToSend = issueType === "bug" ? "" : issueType;
    const formData = Object.assign(
      {},
      {
        files: files,
        title: title,
        body: this.getTicketDescription(),
        userEmails: this.getUserEmails(),
        type: type,
        issueType: this.props.type === "featureRequest" ? type : issueTypeToSend,
        priority: this.props.type === "featureRequest" && "Low",
        issueField: {
          description,
          issuePage,
          problemNature,
          accessibilityFollowUp: this.getAccessibilityFollowUp(),
        },
      }
    );
    Loader.show();
    submitTicket({ payload: this.props.payload, body: formData })
      .then((resp) => {
        Alert.success("Ticket submitted!", () => {
          Loader.hide();
          this.props.closeModal();
        });
      })
      .catch((err) => {
        Loader.hide();
        console.error("Error submitting ticket - ", err);
        Alert.error("Error submitting ticket");
      });
  }

  handleFileUpload(result = []) {
    this.setState({ files: result });
    // this.showStates();
  }

  getTicketDescription = () => {
    const { description, issuePage, problemNature } = this.state;
    const appendedDescription = `
    Description:
    ${description}
    ${
      issuePage &&
      `
      On what page did you encounter this issue?:
      ${issuePage}
    `
    }
    ${
      problemNature &&
      `
    What was the nature of the problem?
    ${problemNature}`
    }
    `;
    return appendedDescription;
  };

  zendeskFormChange(e) {
    e.preventDefault();
    const { target } = e;
    let value = target.value;

    switch (target.type) {
      case "checkbox":
        value = !this.state[target.name];
        break;
      case "text":
        value = target.value;
        break;
      case "radio":
        value = target.value;
        this.updateOptionalChecks(value);
        break;
    }

    this.setState({
      [target.name]: value,
    });
  }

  updateOptionalChecks = (check = null) => {
    const { type } = this.props;
    let formError = {
      title: {
        isError: false,
        type: "text",
      },
      description: {
        isError: false,
        type: "text",
      },
    };
    if (type === "accessibility") {
      Object.assign(
        formError,
        check === "other"
          ? {
              userEmails: {
                isError: false,
                type: "text",
              },
            }
          : {}
      );
    } else if (type === "featureRequest") {
      Object.assign(formError, {
        problemNature: {
          isError: false,
          type: "text",
        },
      });
    }
    else {
      Object.assign(formError, {
        issuePage: {
          isError: false,
          type: "text",
        },
      });
    }
    this.setState({
      formError: formError,
    });
  };

  /**
   * changes userEmails based on radio button
   */
  getUserEmails = () => {
    const { userEmails, userEmailRadio } = this.state;
    const {
      payload: {
        user: { email },
      },
    } = this.props;
    let currentEmail = email;

    switch (userEmailRadio) {
      case "self":
        currentEmail = email;
        break;
      case "other":
        currentEmail = userEmails;
        break;
      default:
        currentEmail = userEmails;
        break;
    }
    return currentEmail;
  };

  /**
   * gets accessibilityFollowUp as per userEmailRadio
   */
  getAccessibilityFollowUp = () => {
    const { userEmailRadio } = this.state;
    switch (userEmailRadio) {
      case "other":
        return "yes";
      case "self":
        return "no";
      default:
        return "no";
    }
  };

  showStates() {
    setTimeout(() => {
      console.log("state - ", this.state);
    }, 5000);
  }

  getForm = ({ payload, type }) => {
    const {
      title,
      description,
      userEmails,
      userEmailRadio,
      issuePage,
      problemNature,
    } = this.state;
    switch (type) {
      case "accessibility":
        return (
          <form class={layoutStyle.formContainer} onSubmit={this.handleSubmit}>
            <fieldset>
              <div className={style.card}>
                <InputText
                  labelText="Subject"
                  inputName="title"
                  onChange={this.zendeskFormChange}
                  inputValue={title}
                  isRequired={true}
                  isError={this.state.formError.title.isError}
                  placeholder="Brief Summary"
                  className={style.inputTextarea}
                />
              </div>
              <div className={style.card}>
                <InputText
                  labelText="During which action or task did you encounter a problem?"
                  inputName="description"
                  onChange={this.zendeskFormChange}
                  inputValue={description}
                  isRequired
                  isError={this.state.formError.description.isError}
                  placeholder="Your answer..."
                  className={style.inputTextarea}
                />
              </div>
              <div className={style.card}>
                <InputText
                  labelText="What was the nature of the problem?"
                  inputName="problemNature"
                  onChange={this.zendeskFormChange}
                  inputValue={problemNature}
                  isRequired={false}
                  placeholder="Your answer..."
                  className={style.inputTextarea}
                />
              </div>
              <div className={style.card}>
                <label id="email-followup">
                  Would you like someone to follow up with you?
                </label>
                <div role="radiogroup" aria-labelledby="email-followup">
                  <div class={style.radioContainer}>
                    <InputRadioButton
                      tabIndex="0"
                      labelText="Yes"
                      inputName="userEmailRadio"
                      onChange={this.zendeskFormChange}
                      inputValue={"other"}
                      checked={userEmailRadio === "other"}
                      className={style.inputRadiobutton}
                    />
                    <InputText
                      inputName="userEmails"
                      onChange={this.zendeskFormChange}
                      inputValue={userEmails}
                      isRequired={userEmailRadio === "other"}
                      isError={
                        userEmailRadio === "other" &&
                        this.state.formError.userEmails.isError
                      }
                      className={`${style.radioInputText} ${
                        userEmailRadio !== "other" ? style.hidden : ""
                      }`}
                      placeholder="Please provide a name or email."
                    />
                  </div>
                  <InputRadioButton
                    labelText="No"
                    inputName="userEmailRadio"
                    onChange={this.zendeskFormChange}
                    inputValue={"self"}
                    checked={userEmailRadio === "self"}
                    className={style.inputRadiobutton}
                  />
                </div>
              </div>
              <div className={style.card}>
                <InputFile
                  inputName="files"
                  handleFileUpload={this.handleFileUpload}
                  payload={payload}
                  label="Add a file, screenshot, or video (Recommended)"
                  files={this.state.files}
                  hideExtraText={true}
                />
              </div>
            </fieldset>
          </form>
        );
        case "featureRequest":
          return (
            <form class={layoutStyle.formContainer} onSubmit={this.handleSubmit}>
              <fieldset>
                <div className={style.card}>
                  <InputText
                    labelText="Summary of feature idea"
                    inputName="description"
                    onChange={this.zendeskFormChange}
                    inputValue={description}
                    isRequired={true}
                    isError={this.state.formError.description.isError}
                    placeholder="What feature would you like us to consider implementing?"
                    className={style.inputTextarea}
                  />
                </div>
                <div className={style.card}>
                  <InputTextArea
                    labelText="Why is this feature important?"
                    inputName="problemNature"
                    onChange={this.zendeskFormChange}
                    inputValue={problemNature}
                    isRequired
                    isError={this.state.formError.problemNature && this.state.formError.problemNature.isError}
                    placeholder="Let us know what issues this feature would solve for or how it would improve your experience on the platform."
                    className={style.inputTextarea}
                  />
                </div>
              </fieldset>
            </form>
          );
      default:
        return (
          <form class={layoutStyle.formContainer} onSubmit={this.handleSubmit}>
            <fieldset>
              <div className={style.card}>
                <InputText
                  labelText="Subject"
                  inputName="title"
                  onChange={this.zendeskFormChange}
                  inputValue={title}
                  isRequired={true}
                  isError={this.state.formError.title.isError}
                  placeholder="Brief Summary"
                  className={style.inputTextarea}
                />
              </div>
              <div className={style.card}>
                <InputTextArea
                  labelText="How can we help?"
                  inputName="description"
                  onChange={this.zendeskFormChange}
                  inputValue={description}
                  isRequired={true}
                  isError={this.state.formError.description.isError}
                  placeholder="What are you trying to do? Where are you getting stuck?"
                  className={style.inputTextarea}
                />
              </div>
              <div className={style.card}>
                <InputText
                  labelText="Users affected (if applicable)"
                  inputName="userEmails"
                  onChange={this.zendeskFormChange}
                  inputValue={userEmails}
                  isRequired={false}
                  className={style.inputTextarea}
                  placeholder="Enter the names and emails of 2-3 affected users"
                />
              </div>
              <div className={style.card}>
                <InputText
                  labelText="Relevant page on the site"
                  inputName="issuePage"
                  onChange={this.zendeskFormChange}
                  inputValue={issuePage}
                  isRequired={true}
                  isError={
                    this.state.formError.issuePage &&
                    this.state.formError.issuePage.isError
                  }
                  placeholder="example: myuniversity.peoplegrove.com/hub/myu/programs-v2"
                  className={style.inputTextarea}
                />
              </div>
              <div className={style.card}>
                <InputFile
                  inputName="files"
                  handleFileUpload={this.handleFileUpload}
                  payload={payload}
                  label="Add a file, screenshot, or video (Recommended)"
                  files={this.state.files}
                  hideExtraText={true}
                />
              </div>
            </fieldset>
          </form>
        );
    }
  };

  render({ onContentClick, payload, type }) {
    const { appError } = payload;
    const buttonText =
      type === "accessibility" ? "Submit Accessibility Issue" : "Submit Ticket";
    return (
      <div>
        <div class={layoutStyle.container}>
          <button
            tabIndex="0"
            aria-label="Go Back"
            class={style.backButton}
            onClick={() => onContentClick(type === "accessibility" ? "Home" : "ShowAdditionalButtons")}
          >
            <PGBackIcon />
          </button>
          {!appError ? (
            type === "accessibility" && (
              <h3 class={style.heading}>Report an accessibility issue</h3>
            )
          ) : (
            <h5>
              Oops! Looks like something went wrong. Please check your internet
              connection and refresh the page to try again. If you continue to
              get this message, please tell us what’s happening and we will get
              back to you soon!
            </h5>
          )}
          <div>
            <div class={layoutStyle.formWrapper}>
              {this.getForm({ payload, type: type })}
            </div>
          </div>
          <Button onClick={this.handleSubmit} className={style.submitButton}>
            {buttonText}
          </Button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/User/ReportIssueV2/index.js